export class Funcionario {
   public cdFuncionario: number;
   public nmFuncionario: string;
   public cnpjCpf: string;	
}
